import * as sonbp from "sonbp";
import * as ifbase from "../base";

/**
 * 編集結果をPDFに保存する。
 */
export function save(ifdto: ifbase.ifDto, callback: (IResult) => void): void {

	// プレビューの赤枠は表示させる。
	//var hiddenItem = undefined;
	//if (ifdto.areaType == '2') {
	//	//仕上がり区分＝銀塩の赤枠はプレビューに表示させない
	//	let layer = ifbase.util.getLayer(ifdto, ifbase.constants.LTYPE_AREA)?.layer;
	//	if (layer) {
	//		let items = ifbase.util.getItems(layer.items, function (item: sonbp.object.baseItem): boolean {
	//			return item.info.vendor_property.ffpsc?.item_type == "AREA_IMG" && item.info.vendor_property.ffpsc?.area_type == 2;
	//		});
	//		if (items.length > 0) {
	//			hiddenItem = items[0];
	//		}
	//	}
	//}

	// [sonbp] 保存
	// 編集状態を保存し、サーバ上のPDFに反映します。
	sonbp.tool.document.save(ifdto.bpView, function (obj) {

		//if (hiddenItem) {
		//	hiddenItem.info.vendor_property.ffpsc.preview_hidden = 1;
		//	hiddenItem.graphic.fill_opacity = 0;
		//}

	}).then(function () {
		// 保存完了
		//if (hiddenItem) {
		//	// 一時保存考慮して表示を復活させておく
		//	hiddenItem.info.vendor_property.ffpsc.preview_hidden = undefined;
		//	hiddenItem.graphic.fill_opacity = 1.0;
		//}
		ifdto.cleareCollbackError();
		callback({ code: 0 });
	}).catch(function (e) {
		// 保存エラー
		ifdto.callbackError(e);
	});
}
